import { Component, Input, OnInit } from '@angular/core';

import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';

@Component({
    selector: 'panel-nav-element',
    templateUrl: './panel-nav-element.component.html',
    styleUrls: ['./panel-nav-element.component.css'],
    standalone: false
})
export class PanelNavElementComponent implements OnInit {
  @Input()
  public selectedPanelId: string;

  @Input()
  public currentPanel: string;

  @Input()
  public officeId: string;

  @Input()
  public officeType: string;

  @Input()
  public isEditMode: boolean;

  @Input()
  public draftId: string;

  @Input()
  public isCreateFlow: boolean;

  @Input()
  public vendor;

  @Input()
  public org;

  @Input()
  public isReplicateFlow: boolean;

  @Input()
  public flowType: string;

  public isDisplayFlow: boolean;
  public isDeleteFlow: boolean;

  constructor(private router: Router) {}
  public ngOnInit(): void {
    switch (this.flowType) {
      case 'replicate':
        this.isReplicateFlow = true;
        break;
      case 'edit':
        this.isEditMode = true;
        break;
      case 'create':
        this.isCreateFlow = true;
        break;
      case 'delete':
        this.isDeleteFlow = true;
        break;
      default:
        this.isDisplayFlow = true;
    }
  }

  public getPanel() {
    let path = '/office/office-detail';

    // incase of edit mode and have draft id,
    // navigate to edit mode panel
    if (this.isEditMode && this.draftId) {
      this.router.navigate([
        path,
        'edit',
        this.officeType,
        this.officeId,
        this.draftId,
        this.selectedPanelId
      ]);
    } else if (this.draftId && !this.vendor) {
      this.router.navigate([
        path,
        this.officeType,
        this.officeId,
        this.draftId,
        this.selectedPanelId
      ]);
    } else if (this.isCreateFlow) {
      this.router.navigate([path, 'create', this.selectedPanelId], {
        queryParams: { vendor: this.vendor, org: this.org }
      });
    } else if (this.isReplicateFlow) {
      this.router.navigate(
        [path, 'edit', 'replicate', this.officeId, this.selectedPanelId],
        { queryParams: { vendor: this.vendor, org: this.org } }
      );
    } else if (this.isDeleteFlow) {
      path = '/office/office-delete';
      this.router.navigate([path, this.officeId, this.selectedPanelId]);
    } else {
      this.router.navigate([
        path,
        this.officeType,
        this.officeId,
        this.selectedPanelId
      ]);
    }
  }
}
